@use 'themes/westfield' as *;
@use 'tools/dirg' as *;
@use 'tools/dirg-breakpoint' as *;
@use 'tools/color' as *;

.wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: units(25);
}

.homeLink {
  color: color('Black');
}

.header {
  @include font-size(4);
  font-weight: 500;
  color: #1c1f24;
  margin-bottom: units(1);

  @include fromBreakpoint(tablet) {
    margin-bottom: units(1.5);
  }
}
